import { Paginator } from '@app/classes';
import { SelectFilter } from '@app/modules/table/classes/table-filters/select-filter.class';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { Department } from '@models/company/department.model';
import { Model } from '@models/core/base.model';
import { TimeOffRequest, TimeOffRequestStatus } from '@models/time-off-v3/time-off-request.model';
import {
    CountAsColumn,
    DescriptionColumn,
    EmployeeColumn,
    RequestDateRangeColumn,
    StatusColumn,
    TimeOffTypeColumn,
} from '@time-off-v3/services/general-time-off-requests-table/columns';

export class GeneralTimeOffRequestTable extends Table {
    static editOption: MenuColumnItem = {
        label: 'time-off-v3.edit',
        event: 'edit',
    };

    static approveOption: MenuColumnItem = {
        label: 'time-off-v3.approve',
        event: 'approve',
    };

    static denyOption: MenuColumnItem = {
        label: 'time-off-v3.deny',
        event: 'deny',
    };

    showMenuColumnOptions = true;
    links = true;

    constructor(
        protected auth: AuthService,
        departments: Department[] = []
    ) {
        super(auth);
        const departmentOptions = departments.map((department) => {
            return { label: department.name, value: department.id };
        });

        this.filters = [
            new SelectFilter('departmentId', departmentOptions, { placeholder: 'time-off-v3.departments' }),
        ];
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new EmployeeColumn(),
            new TimeOffTypeColumn(),
            new DescriptionColumn(),
            new RequestDateRangeColumn(),
            new CountAsColumn(),
            new StatusColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            TimeOffRequest.with([
                'employee',
                'createdBy',
                'timeOffPolicy.timeOffType',
                'timeOffRequestApprovalFlow.forcedBy',
                'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffApprovalFlowStep.timeOffApproverType',
                'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffRequestApprovalFlow',
                'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffRequestApprovals.approver',
            ])
        );
    }

    getMenuColumnOptionsForRow(timeOffRequest: TimeOffRequest): MenuColumnItem[] {
        const baseOption = [GeneralTimeOffRequestTable.editOption];

        if (timeOffRequest.status === TimeOffRequestStatus.denied) {
            return [];
        }

        if (!timeOffRequest.canApproveOrDeny(this.auth.employee)) {
            return baseOption;
        }

        return [...baseOption, GeneralTimeOffRequestTable.approveOption, GeneralTimeOffRequestTable.denyOption];
    }

    getLink(row: Model): (string | number)[] | null {
        return ['/', 'time-off', 'v3', 'requests', row.id];
    }
}
